import StyledLink from '../StyledLink'
import makeQueryString from './makeUrl/makeUrl'
import {
  ASSETS,
  SPACES
} from '../routes'

interface Params {
  importTo?: string
}

interface Props {
  children: React.ReactNode
  spaceId: string
}

const LinkToSpaceAssets = ({
  children,
  spaceId,
  ...params
}: Props & Params) => {
  const url = `/${SPACES}/${spaceId}/${ASSETS}`

  return (
    <StyledLink to={makeQueryString(url, { ...params })}>
      {children}
    </StyledLink>
  )
}

export default LinkToSpaceAssets
